import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-4 5a1 1 0 0 0 -1 1v3h-4v-3a1 1 0 0 0 -.883 -.993l-.117 -.007a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-3h4v3a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-8a1 1 0 0 0 -1 -1","key":"svg-0"}]]

const IconHelicopterLandingFilled = createReactComponent('filled', 'helicopter-landing-filled', 'HelicopterLandingFilled', __iconNode);

export default IconHelicopterLandingFilled;